import { RootState } from "@/store/store";
import { reportsStateSelector } from "@/store/reports/selector/reportsStateSelector";

export const oneTimeReportDetailsSelector = (state: RootState) => {
  return reportsStateSelector(state).oneTimeReportDetails;
};
